import { render, staticRenderFns } from "./specialHoleAndSlotTable.vue?vue&type=template&id=54c8cf36&"
import script from "./specialHoleAndSlotTable.vue?vue&type=script&lang=ts&setup=true&"
export * from "./specialHoleAndSlotTable.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./specialHoleAndSlotTable.vue?vue&type=style&index=0&id=54c8cf36&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports